import { getApiBaseUrl } from "services/utils";
import { useAppSelector } from "utils/redux";

export const getSovidFromUrlIfYouDontHaveReactRouter = (url: string): string => {
  const urlObj = new URL(url);
  // Handle sovId query param (e.g. /email-resend-error?sovId=s-...)
  // before falling back to the last path segment (e.g. /new/maps/s-...).
  return urlObj.searchParams.get("sovId") || urlObj.pathname.split("/").pop() || "";
};

export const useGetViewOnlyUrl = () => {
  const accessToken = useAppSelector((state) => state.auth.accessToken);

  const getViewOnlyUrl = async (sovid: string | null | undefined) => {
    if (!sovid) return { url: null };
    const response = await fetch(`${getApiBaseUrl()}api/v1/pli/policy/${sovid}/get_public_shareable_url`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  };

  return getViewOnlyUrl;
};

export const transformUrl = (url: string) => {
  try {
    let transformedUrl = url;

    // 2) /maps -> /new/maps (only if not already present)
    if (!transformedUrl.includes("/new/maps")) {
      transformedUrl = transformedUrl.replace(/\/maps\b/, "/new/maps");
    }

    // 3) Parse URL (handles relative URLs via current origin)
    const urlObj = new URL(transformedUrl, window.location.origin);

    // 4) If the target is in the same root domain, force host to the current host.
    //    This guarantees dev2 -> dev2, app -> app, etc. (green/blue consistency).
    const currentHost = window.location.hostname; // e.g. dev2.pingintel.com
    const split = (h: string) => h.split(".").filter(Boolean);
    const currentParts = split(currentHost);
    const targetParts = split(urlObj.hostname);

    // naive "root" = last two labels (ok for pingintel.com)
    const root = (parts: string[]) => (parts.length >= 2 ? parts.slice(-2).join(".") : "");

    const currentRoot = root(currentParts);
    const targetRoot = root(targetParts);

    // Only mirror if both look like normal domains and share the same root
    const isIPv4 = (h: string) => /^\d{1,3}(\.\d{1,3}){3}$/.test(h);
    const isLocalhostLike = (h: string) => h === "localhost" || h.endsWith(".localhost") || isIPv4(h);

    const sameRoot = !!currentRoot && !!targetRoot && currentRoot === targetRoot;

    if (!isLocalhostLike(urlObj.hostname) && sameRoot) {
      // Force exact hostname to the current one (covers dev1/dev2/app/etc.)
      urlObj.hostname = currentHost;
    }

    // Local map links should open the UI instead of either product's API.
    if (import.meta.env.VITE_APP_ENV === "local") {
      if (urlObj.port === "8010") urlObj.port = "3010";
    }

    return urlObj.toString();
  } catch (error) {
    console.log("Error transforming URL: ", error);
    return url;
  }
};
